import { Component, OnInit, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-right-menu',
  templateUrl: './image-right-menu.component.html',
  styleUrls: ['./image-right-menu.component.scss'],
  // animations: [
  //   trigger('viewportAnimation', [
  //     state('initial', style({
  //       opacity: 0.0
  //     })),
  //     state('final', style({
  //       opacity: 1.0
  //     })),
  //     transition('initial=>final', animate('2000ms')),
  //     transition('final=>initial', animate('1000ms'))
  //   ]),
  // ]
})
export class ImageRightMenuComponent implements OnInit {

  @Input() header: string;
  @Input() subHeader: string;
  @Input() text: string;
  @Input() img: string = "../../../assets/imgs/Placeholder.png";
  @Input() imgHoverText: string;
  @Input() buttonVisible: boolean;
  @Input() buttonLink: boolean;
  @Input() buttonText: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  currentState = 'initial';

  inViewPort(event)
  {
    if(event.visible == true)
    {
      this.currentState = 'final';
    }
    else{
      this.currentState = 'initial';
    }
  }

  imgClicked(content)
  {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
}
